import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

const MenuHandle = {
  name:   'menuHandle',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const rect           = moveable.getRect();
    const { pos3, pos4 } = moveable.state;
    const x              = pos3[0] + ((pos4[0] - pos3[0]) / 2);
    const y              = pos3[1] + ((pos4[1] - pos3[1]) / 2);
    return React.createElement('div', {
      class: 'extended-button menu-button d-flex align-items-center justify-content-center',
      style: {
        position:        'absolute',
        left:            '0px',
        top:             '0px',
        transform:       `translate(${x}px, ${y}px) rotate(${rect.rotation}deg) translate(4px, 10px)`,
        transformOrigin: '0 0',
      },
      key:     'menu-handle',
      onClick: (event) => {
        event.stopPropagation();
        EventBus.$emit(ApplicationEventTypes.Canvas.OPEN_ELEMENT_MENU, event.currentTarget.getBoundingClientRect());
      },
    }, '');
  },
};
export default MenuHandle;
